import { useCallback, useEffect, useState } from "react";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

export function ScrollTop() {
  const [visible, setVisible] = useState(false);
  const toggleVisible = useCallback(() => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 320) {
      setVisible(true);
    } else if (scrolled <= 320) {
      setVisible(false);
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  });

  return (
    <div className="scroll_button_head">
      {visible && (
        <div
          style={{
            display: "flex",
            background: "#20c997",
            height: "50px",
            width: "50px",

            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            bottom: "10px",
            left: "10px",
            cursor: "pointer",
            borderRadius: "50%",
          }}
          className="scroll_button"
          onClick={scrollToTop}
        >
          <KeyboardArrowUpIcon className="scroll" />
          {/* <span>scroll up</span> */}
        </div>
      )}
    </div>
  );
}
